var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 25C1 11.7452 11.7452 1 25 1V1C38.2548 1 49 11.7452 49 25V25C49 38.2548 38.2548 49 25 49V49C11.7452 49 1 38.2548 1 25V25Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25C27.21 25 29 23.21 29 21C29 18.79 27.21 17 25 17C22.79 17 21 18.79 21 21C21 23.21 22.79 25 25 25ZM25 27C22.33 27 17 28.34 17 31V32C17 32.55 17.45 33 18 33H32C32.55 33 33 32.55 33 32V31C33 28.34 27.67 27 25 27Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactInformationIcon);
export default __webpack_public_path__ + "static/media/contact_information_icon.455eeff11c5d877b0fb392b748f8a75c.svg";
export { ForwardRef as ReactComponent };